import { ICreditPool, ICreditPoolListState } from './interfaces';
import { fetchCreditPoolList } from './creditPoolList.thunk';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: ICreditPoolListState = {
  loading: false,
  creditPools: []
};

const creditPoolListSlice = createSlice({
  name: 'creditPoolList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCreditPoolList.pending, (state: ICreditPoolListState) => {
      state.loading = true;
    });
    builder.addCase(fetchCreditPoolList.fulfilled, (state: ICreditPoolListState, action: PayloadAction<ICreditPool[]>) => {
      state.loading = false;
      state.creditPools = [...action.payload];
    });
    builder.addCase(fetchCreditPoolList.rejected, (state: ICreditPoolListState) => {
      state.loading = false;
    });
  }
});

export const creditPoolListReducer = creditPoolListSlice.reducer;
